<template>
  <div>
    <!-- <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div> -->
    <CCardHeader class="waste-header">
      <slot name="header">
        <span><CIcon name="cil-grid" class="mr-2" /> {{ caption }}</span>
        <CRow>
          <CCol sm="12" class="mb-3">
            <CSelect
              label="Site"
              :options="plantcodeOptions"
              id="plantcodeOptions"
              placeholder="Select Site"
              v-on:change="getShuffledWasteDataFilter()"
            />
          </CCol>
        </CRow>
      </slot>
    </CCardHeader>
    <CRow>
      <CCol sm="12">
        <CTableWrapper
          :items="items"
          hover
          striped
          bordered
          small
          fixed
          caption="Payment Advice"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import CTableWrapper from "./Payment_advice.vue";
import axios from "axios";
export default {
  name: "Payment_advice",
  data() {
    return {
      plantcodeOptions: [],
      siteArr: [],
      Plant_Code: 0,
      items: [],
      clientvise_fromdate_value: "",
      sitevise_todate_value: "",
	  isLoading: false
    };
  },
  props: {
    caption: {
      type: String,
      default: "Payment Advices",
    },
  },
  components: { CTableWrapper },
  mounted() {
    var self = this;

    var token = localStorage.getItem("auth");
    var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
    var requestInfo = {
      Token: token,
      Session_User_Id: Session_User_Id,
    };
    var data = JSON.stringify(requestInfo);
    var config = {
      method: "post",
      url: apiURL + "MasterData/GetSapSites",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
	this.isLoading = true;
    axios(config)
      .then((result) => {
		this.isLoading = false;
        if (result.data.status_code == 200) {
          var obj = result.data.response;
          var siteOptionsArr = obj;

          this.siteArr = obj;
          var siteSingleArr = [];
          var Plant_Code = "";
          localStorage.removeItem("pay_Plant_Code");
          localStorage.removeItem("pay_Customer_Code");
          localStorage.removeItem("pay_Customer_Name");

          var selArr = siteOptionsArr.find(function (jsonitem, i) {
            if (i == 0) {
              Plant_Code = jsonitem.Plant_Code;
              localStorage.setItem("pay_Plant_Code", Plant_Code);
              localStorage.setItem("pay_Customer_Code", jsonitem.Customer_Code);
              localStorage.setItem("pay_Customer_Name", jsonitem.Customer_Name);
            }
            siteSingleArr.push(jsonitem.Plant_Name);
          });
          this.plantcodeOptions = siteSingleArr;

          var self1 = self;
          var token = localStorage.getItem("auth");
          var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
          var requestInfo = {
            Token: token,
            Customer_Code: Session_User_Id,
            Session_User_Id: Session_User_Id,
            Plant_Code: Plant_Code,
          };
          var data = JSON.stringify(requestInfo);
          //console.log(data);
          var config = {
            method: "post",
            url: apiURL + "CustPaymentAdvice/GetCustomerOutStandingPaymentList",
            headers: {
              "Content-Type": "application/json",
            },
            data: data,
          };
          this.isLoading = true;
          axios(config)
            .then((result) => {
			  this.isLoading = false;
              if (result.data.status_code == 200) {
                var obj = result.data.response;
                //console.log(obj);
                var totrow = obj.length;
                var payData = [];
                for (var i = 0; i < totrow; i++) {
                  var Balance_Amount = obj[i].Amount - obj[i].OutStanding_Amt;
                  var row = {
                    Invoice_No: obj[i].BillNo,
                    Invoice_Date: obj[i].BillDate,
                    Invoice_Amount: obj[i].Amount,
                    OutStanding_Amount: obj[i].OutStanding_Amt,
                    Paid_Amount: "",
                    TDS: "",
                    Balance_Amount: Balance_Amount,
                  };
                  payData.push(row);
                }
                this.items = payData;
              } else {
				this.isLoading = false;
                this.$swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: result.data.message,
                });
                this.items = [];
              }
            })
            .catch((error) => {
			  this.isLoading = false;
              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
              });
            });
        } else {
		  this.isLoading = false;
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.data.message,
          });
        }
      })

      .catch((error) => {
		this.isLoading = false;
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  },
  methods: {
    dateFilter_client() {
      console.log("date filter");
      this.getShuffledWasteDataFilter();
    },
    getShuffledWasteDataFilter() {
      //console.log('call');
      var value = $("#plantcodeOptions").val();
      var siteOptionsArr = this.siteArr;
      var self = this;
      var Plant_Code = "2302";
      var selArr = siteOptionsArr.find(function (jsonitem, i) {
        if (value == jsonitem.Plant_Name) {
          Plant_Code = jsonitem.Plant_Code;

          localStorage.setItem("pay_Plant_Code", Plant_Code);
          localStorage.setItem("pay_Customer_Code", jsonitem.Customer_Code);
          localStorage.setItem("pay_Customer_Name", jsonitem.Customer_Name);
          //console.log(Plant_Code);
        }
      });

      var firstdate = $("#clientvise_fromdate").val();
      var today = $("#clientvise_todate").val();
      var token = localStorage.getItem("auth");
      var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
      var requestInfo = {
        Token: token,
        Customer_Code: Session_User_Id,
        Session_User_Id: Session_User_Id,
        Plant_Code: Plant_Code,
      };
      var data = JSON.stringify(requestInfo);
      //console.log(data);
      var config = {
        method: "post",
        url: apiURL + "CustPaymentAdvice/GetCustomerOutStandingPaymentList",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      var self = this;
	  this.isLoading = true;
      axios(config)
        .then((result) => {
			this.isLoading = false;
          if (result.data.status_code == 200) {
            var obj = result.data.response;
            //console.log(obj);
            var totrow = obj.length;
            var payData = [];
            for (var i = 0; i < totrow; i++) {
              var Balance_Amount = obj[i].Amount - obj[i].OutStanding_Amt;
              var row = {
                Invoice_No: obj[i].BillNo,
                Invoice_Date: obj[i].BillDate,
                Invoice_Amount: obj[i].Amount,
                OutStanding_Amount: obj[i].OutStanding_Amt,
                Paid_Amount: "",
                TDS: "",
                Balance_Amount: Balance_Amount,
              };
              payData.push(row);
            }
            this.items = payData;
          } else {
			this.isLoading = false;
            this.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.message,
            });
            this.items = [];
          }
        })
        .catch((error) => {
		  this.isLoading = false;
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });
    },
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
      return array;
    },
    add() {
      //console.log('add');
    },
  },
};
</script>
